<template>

   <div id="footer" class="container">
       <p>&nbsp;</p>
       <div class="smalltext"><strong>All contents copyright 2020</strong> <a href="http://www.jimwcoleman.com" style="color: blue;">Jim W Coleman</a> and the estate of Barbara Nell Schmidt, wife of the late Daniel Field Schmidt.<br />
           <span class="tinytext">This website and its contents were commissioned by the estate of Barbara Nell Schmidt, wife of the late Daniel Field Schmidt.</span></div>
  </div>
</template>

<script>
  export default {
    name: 'FooterBar.vue'
  }
</script>

<style scoped>
    .smalltext {
        font-size: .70em;
        background-color: white;
        color: lightslategrey;
        text-align: center;
        padding: 0 0;
    }
    .tinytext{
        font-size: .65em;
        background-color: white;
        text-align: center;
        color: blue;
    }
    .container {
        max-width: 100vw;
        height:30px;
        max-height: 30px;
        background-color: #fff;
        padding: 50px 0 0 0;
        margin: 0;
    }
    .footer {
        text-align: center;
    }
</style>
